module.exports = __webpack_public_path__ + "static/assets/1fa6345d57ffc67eccd9f44cf6a383dd.svg";